// extracted by mini-css-extract-plugin
export default {"heading":"Technologies_heading__PFHYP","grid-container":"Technologies_grid-container__jCtPP","grid-item":"Technologies_grid-item__bEHFQ"};